<template>
  <div class="cashflow-type-income card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="income.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.incomeProgress.recommendedLabel"
                      :up-to-now-label="titles.incomeProgress.actualsLabel"
                      :up-to-now-amount="income.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :ref="'income-category-section-1'"
                                 :actuals-title="titles.categorySections.fixedIncome.actualsTitle"
                                 :recommended-title="titles.categorySections.fixedIncome.recommendedTitle"
                                 :categories="income.fixedIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="true"
                                 :expense-category="titles.cashflowType"
                                 :title="titles.categorySections.fixedIncome.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <predicted-transaction-row class="transaction-details"
                           v-for="transaction in transactions"
                           :predicted-transaction="transaction"
                           v-bind:key="transaction.transactionId"
                           v-on:trash-clicked="trashClicked(CASHFLOW_TYPE, $event)">

          </predicted-transaction-row>
        </div>
      </template>
    </predicted-category-sections>

    <predicted-category-sections :ref="'income-category-section-2'"
                                 :actuals-title="titles.categorySections.variableIncome.actualsTitle"
                                 :recommended-title="titles.categorySections.variableIncome.recommendedTitle"
                                 :categories="income.variableIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="this.isPredictedIncome"
                                 :title="titles.categorySections.variableIncome.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction-row class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="categoryName"
                                     v-bind:key="transaction.transactionId">

          </transaction-row>
        </div>
      </template>
    </predicted-category-sections>
    <remaining-variable-income/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import PredictedTransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedTransacionRow.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import TransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/TransactionRow.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import RemainingVariableIncome from '../RemainingVariableIncome.vue';


export default {
  name: 'CashflowTypeIncome',
  mixins: [CashflowAnalytics],
  components: {
    RemainingVariableIncome,
    TransactionRow,
    ExpenseProgress,
    PredictedTransactionRow,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree', 'focusIncomePrediction']),
    ...mapGetters('cashflowView', ['isPredictedIncome']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.income;
    },
    income() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    categoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.VARIABLE_INCOME;
    },
    titles() {
      return {
        incomeProgress: {
          actualsLabel: 'נכנס עד עכשיו',
          recommendedLabel: 'סה״כ צפוי להיכנס',
        },
        categorySections: {
          fixedIncome: {
            actualsTitle: 'נכנס',
            recommendedTitle: 'צפוי להיכנס',
            mainTitle: 'פירוט הכנסות קבועות',
          },
          variableIncome: {
            actualsTitle: 'נכנס',
            recommendedTitle: 'צפוי להיכנס',
            mainTitle: 'פירוט הכנסות משתנות',
          },
        },
        cardTitle: 'הכנסות',
        cashflowType: 'הכנסות',
      };
    },
  },
  methods: {
    ...mapActions('cashflowView', ['setFocusIncomePrediction']),
  },
  watch: {
    focusIncomePrediction(newVal) {
      if (newVal) {
        this.$refs['income-category-section-1'].expand();
        this.$refs['income-category-section-2'].expand();
      }
      this.setFocusIncomePrediction({ focus: false });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-income {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_green;
    }

    .cashflow-type-background-color {
      background-color: $riseup_green;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/types/CashflowTypeIncome.vue